import {
  initGlobalState,
  registerMicroApps,
  start,
  addErrorHandler,
  addGlobalUncaughtErrorHandler,
} from "qiankun";
import Cookie from "js-cookie";
export function startQiankun(props) {
  const loader = (loading) => {
    props.setLoading(loading);
  };

  addErrorHandler((err) => {
    // err.appOrParcelName：出错的子应用名称
    console.log("[qiankun error]:", err);
    props.setErrorMessage(err);
  });

  // 定义获取全局状态的函数
  const getGlobalState = () => ({
    micro: {
      /**
       * 业务类型
       * domestic: 国内业务
       * overseas: 海外业务
       * 该值会传递给子应用，子应用可以根据该值进行不同的业务逻辑处理
       * 注意：该值仅在主应用中设置，子应用中不需要设置
       * 子应用可以通过 onGlobalStateChange 监听该值的变化
       * 例如：onGlobalStateChange((state) => { console.log(state.businessType); });
       */
      businessType: "domestic",
      businessToken: Cookie.get("token"), // 业务token
      businessMenu: JSON.parse(localStorage.getItem("menu")) || [], // 业务menu
      businessUserId: localStorage.getItem("pUserId") || null, // 业务用户ID
      businessUserName: localStorage.getItem("pUserName") || null,
    },
  });

  // 初始化全局状态
  const { onGlobalStateChange, setGlobalState } = initGlobalState(getGlobalState());

  // 标记是否已经初始化过
  let isStateInitialized = false;

  registerMicroApps(
    [
      {
        name: "micro-sub-app",
        // entry: "http://localhost:7101",
        // entry: "http://localhost:7105/micro-sub-app/",
        // entry: "http://beta.platform.liberlive-music.com/micro-sub-app",
        // entry: "/micro-sub-app",
        entry: process.env.VUE_APP_QIANKUN,
        container: "#subapp-viewport",
        loader,
        activeRule: "/micro-app",
      },
    ],
    {
      beforeLoad: [
        (app) => {
          console.log("[before load]", app.name);
          // 只在首次加载时设置全局状态，避免重复触发
          if (!isStateInitialized) {
            const latestState = getGlobalState();
            console.log("[before load] 首次设置全局状态:", latestState);
            setGlobalState(latestState);
            isStateInitialized = true;
          }
        },
      ],
      beforeMount: [
        (app) => {
          console.log("[before mount]", app.name);
        },
      ],
      afterUnmount: [
        (app) => {
          console.log("[after unmount]", app.name);
        },
      ],
    }
  );

  onGlobalStateChange((value, prev) =>
    console.log("[onGlobalStateChange - master]:", value, prev)
  );

  start({
    prefetch: process.env.NODE_ENV === "development" ? "none" : "all",
    // sandbox: { strictStyleIsolation: true },
    // 新增：指定微应用状态保存方式
    keepAlive: false,
  });

  // 返回方法供外部调用，用于手动更新全局状态（例如：登录后更新 token）
  return {
    updateGlobalState: () => {
      const latestState = getGlobalState();
      console.log("[手动更新] 更新全局状态:", latestState);
      setGlobalState(latestState);
    },
    setGlobalState,
    onGlobalStateChange
  };
}
